import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'src/common/withStyles';

import { decorateComponent, getClassNameFor } from '../../../helpers';
import s from './AvailabilityDay.module.scss';

const AvailabilityDay = ({ children, classNameModifier = '' }) => (
  <>
    <div className={getClassNameFor(s, 'root', classNameModifier)}>
      <div className={s.date}>
        {children}
      </div>
    </div>
    <div className={getClassNameFor(s, 'border', classNameModifier)} />
  </>
);

AvailabilityDay.propTypes = {
  children: PropTypes.node.isRequired,
  classNameModifier: PropTypes.string,
};

const decorators = [
  withStyles(s),
];

export default decorateComponent(AvailabilityDay, decorators);
